// @flow

import unifizeUser from "../index";
import Remove from "src/components/user/ImageLabel/Remove";

export default unifizeUser(Remove);
